import styled from 'styled-components';

export const JobName = styled.div`
  color: var(--color-text);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  margin: 10px 0 0;

  a {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    color: var(--color-text);
  }
`;
